/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import * as React from 'react';
import { useRecordContext, Labeled } from 'react-admin';
import _get from 'lodash/get';

import { ASSET_TYPE } from '../models/asset';

const ModelExtraData = (props) => {
  const record = useRecordContext(props);
  return record && record.type === ASSET_TYPE.MODEL ? (
    <Labeled label={props.label || props.source}>
      <span>{_get(record, props.source)}</span>
    </Labeled>
  ) : null;
};

export default ModelExtraData;
